import { render, staticRenderFns } from "./ProductLists.vue?vue&type=template&id=5e57b5ce&scoped=true"
import script from "./ProductLists.vue?vue&type=script&lang=js"
export * from "./ProductLists.vue?vue&type=script&lang=js"
import style0 from "./ProductLists.vue?vue&type=style&index=0&id=5e57b5ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e57b5ce",
  null
  
)

export default component.exports